/** Staff schedule print route (opens in a new tab). */
export const staffSchedulePrintUrl = (patientId, chartId) => {
  const base = `/patients/${patientId}/staff-schedule/print`;
  if (chartId == null || chartId === "") return base;
  return `${base}?chartId=${encodeURIComponent(chartId)}`;
};
